import React, { useContext } from 'react';
import { Tab, Nav, Row, Col, Table, Form, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import StarRating from 'components/common/StarRating';
import createMarkup from 'helpers/createMarkup';
import { ProductContext } from 'context/Context';
import { Trans } from 'react-i18next';
import y from 'y4/Utils';
import PdfViewer from 'y4/layouts/content/form/PdfViewer';

const ProductDetailsFooter = ({
  product: { description, specification, reviews, pdf }
}) => {
  const {
    productsState: { config }
  } = useContext(ProductContext);
  return (
    <div className="overflow-hidden mt-4">
      <Tab.Container
        defaultActiveKey={description ? 'description' : 'specifications'}
      >
        <Nav variant="tabs">
          {description ? (
            <Nav.Item>
              <Nav.Link
                eventKey="description"
                className="ps-0 cursor-pointer outline-none"
              >
                <Trans ns="commerce">Description</Trans>
              </Nav.Link>
            </Nav.Item>
          ) : null}
          <Nav.Item>
            <Nav.Link
              eventKey="specifications"
              className="px-2 px-md-3 cursor-pointer outline-none"
            >
              <Trans ns="commerce">Specifications</Trans>
            </Nav.Link>
          </Nav.Item>
          {config.withReview ? (
            <Nav.Item>
              <Nav.Link
                eventKey="reviews"
                className="px-2 px-md-3 cursor-pointer outline-none"
              >
                <Trans ns="commerce">Reviews</Trans>
              </Nav.Link>
            </Nav.Item>
          ) : null}
          {pdf ? (
            <Nav.Item>
              <Nav.Link
                eventKey="pdf"
                className="ps-0 cursor-pointer outline-none"
              >
                <Trans ns="commerce">PDF</Trans>
              </Nav.Link>
            </Nav.Item>
          ) : null}
        </Nav>
        <Tab.Content>
          {description ? (
            <Tab.Pane eventKey="description">
              <div
                className="mt-3"
                dangerouslySetInnerHTML={createMarkup(description)}
              />
            </Tab.Pane>
          ) : null}
          <Tab.Pane eventKey="specifications">
            <Table className="fs--1 mt-3">
              <tbody>
                {y.isEmpty(specification)
                  ? null
                  : Object.keys(specification).map(spec => (
                      <tr key={spec}>
                        <td className="bg-100" style={{ width: '30%' }}>
                          {spec}
                        </td>
                        <td>{specification[spec]}</td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </Tab.Pane>
          {config.withReview ? (
            <Tab.Pane eventKey="reviews">
              <Row className="mt-3">
                <Col lg={6} className="mb-4 mb-lg-0">
                  {reviews.map((review, index) => (
                    <div key={review.id}>
                      <div className="mb-1">
                        <StarRating
                          className="fs--1"
                          readonly
                          rating={review.rating}
                        />
                        <span className="ms-3 text-dark fw-semi-bold">
                          {review.title}
                        </span>
                      </div>
                      <p className="fs--1 mb-2 text-600">
                        By {review.author} • {review.date}
                      </p>
                      <p className="mb-0">{review.text}</p>
                      {!(index === reviews.length - 1) && (
                        <hr className="my-4" />
                      )}
                    </div>
                  ))}
                </Col>
                <Col lg={6} className="ps-lg-5">
                  <Form>
                    <h5 className="mb-3">Write your Review</h5>
                    <div className="mb-3">
                      <Form.Label className="mb-0">Rating:</Form.Label>
                      <StarRating className="d-block fs-3" rating={0} />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Name:</Form.Label>
                      <Form.Control type="text" />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Email:</Form.Label>
                      <Form.Control type="text" />
                    </div>
                    <div className="mb-3">
                      <Form.Label>Review:</Form.Label>
                      <Form.Control as="textarea" rows="3" type="text" />
                    </div>
                    <Button variant="primary" type="submit">
                      Submit
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Tab.Pane>
          ) : null}
          {pdf ? (
            <Tab.Pane eventKey="pdf">
              <PdfViewer documentUrl={pdf} />
            </Tab.Pane>
          ) : null}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

ProductDetailsFooter.propTypes = {
  product: PropTypes.shape({
    description: PropTypes.string,
    specification: PropTypes.object,
    reviews: PropTypes.arrayOf(PropTypes.object),
    pdf: PropTypes.string
  })
};

export default ProductDetailsFooter;
